<span class="sh-snackbar-message" matSnackBarLabel [innerHTML]="data.message"></span>
<span matSnackBarActions>
	<button mat-button matSnackBarAction class="sh-snackbar-dismiss-button" (click)="snackBarRef.dismiss()">
		{{ data.dismissText }}
	</button>
</span>
